export default __webpack_public_path__ + "static/media/AMS_23_10_2024.b9060b34.png";